// extracted by mini-css-extract-plugin
module.exports = {"mainFooter":"footer_mainFooter__25PkE","messageInFooter":"footer_messageInFooter__3X7HA"};